/* Models */
import { Show } from '../models';

/* ActionTypes */
import { SHOW_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const showsReducer = generateEntityReducer(SHOW_ENTITY_ACTION_TYPES, Show);

export default showsReducer;
